import { get } from "@ember/object"
import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"

export default class TimelineRoute extends Route {
  @service
  modalManager

  deactivate() {
    let modalName = "planner/course/timeline/sidebar"
    if (get(this, `modalManager.openedModals.${modalName}.isVisible`)) {
      this.modalManager.closeModal("planner/course/timeline/sidebar")
    }
  }
}
